import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-device-peripheral-breadcrumb-card',
  templateUrl: './device-peripheral-breadcrumb-card.component.html',
  styleUrls: ['./device-peripheral-breadcrumb-card.component.scss']
})
export class DevicePeripheralBreadcrumbCardComponent implements OnInit {

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  public gotoDeviceDetail() {
    const internalId = this.activatedRoute.snapshot.params['deviceid'];
    this.router.navigate(['/device', internalId]);
  }
}
